"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.dateTimePickerBase = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _DatePicker = _interopRequireDefault(require("@mui/lab/DatePicker/DatePicker.js"));

var _LocalizationProvider = _interopRequireDefault(require("@mui/lab/LocalizationProvider/LocalizationProvider.js"));

var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));

var _AdapterDayjs = _interopRequireDefault(require("@mui/lab/AdapterDayjs"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _Input = require("../Input");

var _CalendarIcon = _interopRequireDefault(require("../../assets/Icons/CalendarIcon"));

var _excluded = ["hint", "margin", "width"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dateTimePickerBase = _objectSpread(_objectSpread({}, _Input.inputBaseStyles), {}, {
  '& .MuiInputLabel-formControl': {
    top: '-5px',
    left: 12,
    position: 'absolute',
    transform: 'translate(0, 21px) scale(1)',
    zIndex: 1
  },
  '& .MuiInputLabel-root': {
    display: 'block',
    transformOrigin: 'top left'
  },
  '& .MuiInputLabel-shrink': {
    transform: 'translate(0, 12px) scale(0.75)',
    transformOrigin: 'top left'
  },
  '& .MuiInputLabel-filled': {
    zIndex: 1,
    transform: 'translate(12px, 20px) scale(1)',
    pointerEvents: 'none'
  },
  '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
    transform: 'translate(12px, 10px) scale(0.75)'
  },
  '& .MuiInputLabel-animated': {
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms'
  },
  '& input': {
    padding: '27px 12px 10px'
  }
});

exports.dateTimePickerBase = dateTimePickerBase;
var useStyles = (0, _makeStyles.default)({
  root: _objectSpread(_objectSpread({}, dateTimePickerBase), {}, {
    '& .MuiFormHelperText-root': {
      fontSize: '11px',
      color: function color(_ref) {
        var error = _ref.error;
        return error ? _Colors.default.warningRed : _Colors.default.secondaryGrey;
      },
      margin: '0 13px',
      position: 'absolute',
      overflow: 'hidden',
      bottom: '-16px',
      height: '16px',
      lineHeight: '16px'
    },
    '& button': {
      marginTop: '4px',
      marginRight: '6px',
      '& > svg': {
        marginRight: '0 !important'
      }
    }
  }),
  datePickerWrapper: function datePickerWrapper(_ref2) {
    var width = _ref2.width,
        margin = _ref2.margin;
    return {
      width: width,
      margin: margin,
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Lato'
    };
  },
  popper: function popper() {
    return {
      '& .MuiCalendarPicker-root': {
        '& div': {
          fontFamily: 'Lato',
          fontWeight: 400,
          fontSize: 18
        },
        '& button': {
          fontFamily: 'Lato',
          fontWeight: 400,
          fontSize: 15,
          lineHeight: 'normal',
          '&:focus.Mui-selected': {
            backgroundColor: _Colors.default.orange
          }
        }
      }
    };
  }
});

var DatePicker = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var hint = _ref3.hint,
      margin = _ref3.margin,
      width = _ref3.width,
      rest = _objectWithoutProperties(_ref3, _excluded);

  var disabled = rest.disabled,
      error = rest.error,
      readOnly = rest.readOnly,
      onError = rest.onError,
      renderInput = rest.renderInput;

  var _useStyles = useStyles({
    error: error,
    width: width,
    margin: margin
  }),
      datePickerWrapper = _useStyles.datePickerWrapper,
      popper = _useStyles.popper,
      root = _useStyles.root;

  return /*#__PURE__*/_react.default.createElement(_LocalizationProvider.default, {
    dateAdapter: _AdapterDayjs.default
  }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, _extends({
    renderInput: renderInput !== null && renderInput !== void 0 ? renderInput : function (params) {
      return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, params, {
        ref: ref,
        variant: "standard",
        color: "primary",
        className: "".concat(root, " ").concat(datePickerWrapper, " ").concat(readOnly ? 'isReadOnly' : '', " ").concat(disabled ? 'isDisabled' : ''),
        helperText: hint,
        onError: onError
      }));
    },
    showToolbar: false,
    components: {
      OpenPickerIcon: function OpenPickerIcon(params) {
        return /*#__PURE__*/_react.default.createElement(_CalendarIcon.default, _extends({
          fill: _Colors.default.textElementGrey
        }, params, {
          style: {
            marginRight: '12px'
          }
        }));
      }
    },
    PopperProps: {
      className: popper
    }
  }, rest)));
});

var _default = DatePicker;
exports.default = _default;